import {
    HttpResponse,
    QueryModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import { TenantUserModel } from "../Api";

export class TenantUsersDataService implements CrudService<TenantUserModel, TenantUserModel> {
    getAll(query: CrudDataQuery<TenantUserModel>): Promise<CrudEnumerableResponse<TenantUserModel>> {
        return ApiService.api.getTenantUserBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<TenantUserModel>): Promise<CrudEnumerableResponse<TenantUserModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<TenantUserModel>> {
        return ApiService.api.getTenantUserById(id, params);
    }

    create(item: TenantUserModel, params?: RequestParams): Promise<CrudResponse<TenantUserModel>> {
        return ApiService.api.insertTenantUser(item, params);
    }

    update(item: TenantUserModel, params?: RequestParams): Promise<TenantUserModel> {
        return ApiService.api.updateTenantUser(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<TenantUserModel> {
        throw new Error('NotImplemented');
    }

    delete(query: CrudDataQuery<TenantUserModel>): Promise<CrudEnumerableResponse<TenantUserModel>> {
        return ApiService.api.deleteTenantUsers(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationTenantUser(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<TenantUserModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: TenantUserModel, params?: RequestParams): Promise<CrudResponse<TenantUserModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error('NotImplemented');
    }

}
